<template>
  <div class="login-container">
    <div class="main-box">
      <img class="login-bg" src="../assets/images/WechatIMG190.png" alt="宿舍管理系统">
      <div class="login-box">
        <div class="login-title">宿舍管理系统欢迎您</div>
        <el-form ref="form" :model="form" :rules="rules" size="large">
          <el-form-item v-if="form.identity === 'student'" prop="phone_num">
            <el-input v-model="form.phone_num" clearable prefix-icon="Iphone" placeholder="请输入手机号"></el-input>
          </el-form-item>
          <el-form-item v-else prop="username">
            <el-input v-model="form.username" clearable prefix-icon="User" placeholder="请输入用户名"></el-input>
          </el-form-item>
          <el-form-item prop="password">
            <el-input v-model="form.password" prefix-icon="Lock" show-password placeholder="请输入密码"></el-input>
          </el-form-item>
          <el-form-item prop="identity">
            <el-radio-group v-model="form.identity" :class="{ 'mobile-radio': isMobile }">
              <el-radio value="student">学员</el-radio>
              <el-radio value="dormManager">宿舍管理员</el-radio>
              <el-radio value="approver">审批员</el-radio>
              <el-radio value="admin">系统管理员</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item>
            <el-button style="width: 100%" type="primary" @click="login">登 录</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>
<script src="@/assets/js/Login.js"></script>
<style scoped>
@import '../assets/css/Login.css';
.mobile-radio {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
}
</style>